import type { MouseEventHandler, ReactNode } from 'react'
import React from 'react'
import * as S from './Drawer.styled'
import type { DrawerBodyProps, DrawerProps } from './types'

export const Drawer = ({ children }: DrawerProps) => {
  return children
}

const DrawerBody = ({ position, width = 320, overlay, children }: DrawerBodyProps) => {
  return (
    <S.Drawer>
      <S.Body key="Drawer.Body" $position={position} $width={width}>
        {children}
      </S.Body>

      {overlay}
    </S.Drawer>
  )
}

type DrawerOverlayProps = {
  onClick?: MouseEventHandler<HTMLDivElement>
}

const DrawerOverlay = ({ onClick }: DrawerOverlayProps) => {
  return <S.Overlay onClick={onClick} key="Drawer.Overlay" data-testid="Drawer.Overlay" />
}

type DrawerHeaderProps = {
  size?: 'medium' | 'large'
  children?: ReactNode
}

const DrawerHeader = ({ size = 'medium', children }: DrawerHeaderProps) => {
  return <S.Header $size={size}>{children}</S.Header>
}

Drawer.Body = DrawerBody
Drawer.Overlay = DrawerOverlay
Drawer.Header = DrawerHeader
Drawer.Navigation = S.Navigation
Drawer.Content = S.Content
Drawer.Section = S.Section
Drawer.Footer = S.Footer
